// @flow
import React, { type Element } from 'react';
import type { ServiceProvider } from '../../../../../../../app/types';
import './CategorizedList.scss';
import BusinessCard from './BusinessCard';

export type CategorizedListProps = {
  sortField: string,
  serviceProviders: ServiceProvider[],
  onCardClicked: (id: number, proType: string) => void,
  productInfoFeatureFlag: boolean,
};

const getRegion = ({
  region = {},
} = {}) => region.name;

const renderInfoPanel =
  (letter: string, sps: any, onCardClicked: any, productInfoFeatureFlag: boolean) => (
    <div className="letter-section" key={letter}>
      <div className="letter-header">{letter}</div>
      {
          sps.map(sp => (<BusinessCard
            key={sp.id}
            sp={sp}
            onCardClicked={onCardClicked}
            productInfoFeatureFlag={productInfoFeatureFlag}
          />))
      }
    </div>
  );

const byState = (value: ServiceProvider) => getRegion(value.primaryAddress);
const byName = value => value.name.charAt(0).toUpperCase();

const getSortField = (field) => {
  switch (field) {
    case 'state':
      return byState;
    case 'name':
    default:
      return byName;
  }
};

export const CategorizedListComponent = (props: CategorizedListProps): Element<"div"> => {
  const {
    sortField,
    onCardClicked,
    serviceProviders,
    productInfoFeatureFlag,
  } = props;
  const sps = serviceProviders || [];

  const letterToSps = sps.reduce((acc, value: ServiceProvider) => {
    const key = getSortField(sortField)(value);
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(value);
    return acc;
  }, {});

  return (
    <div>
      {
        Object.entries(letterToSps).map(([l, orderedSps]) =>
          renderInfoPanel(l, orderedSps, onCardClicked, productInfoFeatureFlag))
      }
    </div>
  );
};

export default CategorizedListComponent;



// WEBPACK FOOTER //
// ./src/modules/home/modules/browser/home/BusinessList/components/CategorizedList.js